import Select from 'react-select-plus'
import AvailabilitySlotSelect from 'components/settings/meetings/AvailabilitySlotSelect'

import { TIMEZONE_OPTIONS } from 'components/Customize/Availability/Constants'

import './style.styl'

const TeamAvailabilityPicker = ({
  settings,
  addSlot,
  removeSlot,
  handleSelectDayOfWeek,
  handleSelectStartTime,
  handleSelectEndTime,
  showRemoveSlotUI,
  selectTimezone,
}) => {
  const openHours = settings.get('openHours')
  const timezone = settings.get('timezone')
  return (
    <div className="team-hours-picker-container drift-form">
      <div className="timezone-select">
        <div className="team-hours-label">Timezone</div>
        <div className="team-hours-input">
          <Select
            value={timezone}
            searchable={true}
            clearable={false}
            options={TIMEZONE_OPTIONS}
            onChange={selectTimezone}
            className="team-hours-timezone-select"
          />
        </div>
      </div>

      <div className="team-hours-slots">
        <div className="team-hours-label">Scheduled Hours</div>
        {openHours.map((value, slot) => {
          const hours = value.toJS()
          const { dayOfWeek, startTime, endTime } = hours
          return (
            <div key={`${slot}-${JSON.stringify(hours)}`} className="team-hours-input">
              <AvailabilitySlotSelect
                key={`${value}-${slot}`}
                index={slot}
                dayOfWeek={dayOfWeek}
                startTime={startTime}
                endTime={endTime}
                onSelectDayOfWeek={handleSelectDayOfWeek}
                onSelectStartTime={handleSelectStartTime}
                onSelectEndTime={handleSelectEndTime}
                onRemove={removeSlot}
                hideRemove={!showRemoveSlotUI}
              />
            </div>
          )
        })}
        <div className="add-time-slot">
          <a onClick={addSlot}>+ Add Time</a>
        </div>
      </div>
    </div>
  )
}

export default TeamAvailabilityPicker



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamAvailabilityPicker/component.js